import { HhtmSource } from '@hh.ru/analytics-js-events/build/xhh/employer/resume/resume_key_skill_vacancy_match_element_shown';

import { SkillsMatchedProps } from 'src/components/ResumeCard/Header/Tags/SkillsMatched';
import { useVacancyId } from 'src/components/ResumeCard/hooks/useVacancyId';
import { useSelector } from 'src/hooks/useSelector';

interface Props {
    resumeId: number;
}
type UseSkillsMatchedDataHook = (props: Props) => SkillsMatchedProps | null;

export const useSkillsMatchedData: UseSkillsMatchedDataHook = ({ resumeId }) => {
    const hhtmSource = useSelector((state) => state.analyticsParams.hhtmSource);

    const vacancyId = useVacancyId();
    const vacancyToResumeSkillMatch = useSelector((state) => state.vacancyToResumeSkillMatch);

    const matchedKeySkillPercent = vacancyToResumeSkillMatch?.[resumeId]?.match_by_skills_statistics?.match_percentage;

    if (!matchedKeySkillPercent) {
        return null;
    }

    return {
        hhtmSource: hhtmSource as HhtmSource,
        resumeId,
        vacancyId: Number(vacancyId),
        matchedKeySkillPercent,
    };
};
